//export const HOST = 'https://apimv.ticservice.org:17100/';
export const HOST = process.env.REACT_APP_API_URL;
export const VERSION = 'api/v1/';

const APP_URL = {
    // AUTH
    LOGIN: `${HOST}${VERSION}auth/login/`,
    //HOME
    SELECTDB: `${HOST}${VERSION}admin/request/selectdb`,
    LISTSTATEFORNUMBER: `${HOST}${VERSION}admin/request/listStateForNumber`,
    VERIRYNUMBEREXCEL: `${HOST}${VERSION}admin/request/verifyNumbersExcel`,
    VALIDATENUMBERSTATEEXCEL: `${HOST}${VERSION}admin/request/validateNumberStateExcel`,
    VERIRYNUMBERASESOREXCEL: `${HOST}${VERSION}admin/request/verifyNumbersAsesorExcel`,
    LOADNUMBERSCREATEEXCEL: `${HOST}${VERSION}admin/request/loadNumbersCreateExcel`,
    LOADNUMBERSSTATECREATEEXCEL: `${HOST}${VERSION}admin/request/loadNumbersStateCreateExcel`,
    LOADNUMBERSTRASHEXCEL: `${HOST}${VERSION}admin/request/loadNumbersTrashExcel`,
    LOADNUMBERSTIPIFYCALLS: `${HOST}${VERSION}admin/request/loadNumbersTipifyCalls`,
    LISTNUMBERTIPIFYCALLS: `${HOST}${VERSION}admin/request/listNumbersTipifyCalls`,
    FILTERNUMBERTIPIFYCALLS: `${HOST}${VERSION}admin/request/filterNumbersTipifyCalls`,
    LOADNUMBERS: `${HOST}${VERSION}admin/request/loadNumbers`,
    LOADNUMBERSVII: `${HOST}${VERSION}admin/request/loadNumbersvii`,
    DOWNLOADEXCELNUMBER: `${HOST}${VERSION}admin/request/downloadExcelNumber`,
    DOWNLOADEXCELNUMBERTIPIFYCALLS: `${HOST}${VERSION}admin/request/downloadNumbersTipifyCalls`,
    VIEWLISTLOG: `${HOST}${VERSION}admin/request/viewListLog`,
    LISTTRASHNUMBER: `${HOST}${VERSION}admin/request/listTrashNumber`,
    LISTLOGSBACKUPS: `${HOST}${VERSION}admin/request/listLogsBackups`,
    LISTDBBACKUPS: `${HOST}${VERSION}admin/request/listDBBackups`,
    DELETEDBBACKUP: `${HOST}${VERSION}admin/request/deleteDBBackup`,
    CREATEBDBACKUPS: `${HOST}${VERSION}admin/request/createBdBackups`,
    BACKUPDATABASE: `${HOST}${VERSION}admin/request/backupDatabase`,

    LISTUSERS: `${HOST}${VERSION}admin/users/list`,
    CREATEUSERS: `${HOST}${VERSION}admin/users/create`,
    TOTALSALES: `${HOST}${VERSION}admin/request/totalSales`,
    TOTALSALESRENEW: `${HOST}${VERSION}admin/request/totalSalesRenew`,
    TOTALSALESAGENTS: `${HOST}${VERSION}admin/request/totalSalesAgents`,
    INDICADORESBASE: `${HOST}${VERSION}admin/request/indicadoresBase`,

    LISTPROVIDER: `${HOST}${VERSION}admin/provider/list`,
    LISTCREATENUMBERS: `${HOST}${VERSION}admin/provider/listCreateNumbers`,
    GET_PROVIDER_NUMBERS_DETAIL: `${HOST}${VERSION}admin/provider/providerNumbersDetail`,
    CREATEPROVIDER: `${HOST}${VERSION}admin/provider/create`,
    UPDATEPROVIDER: `${HOST}${VERSION}admin/provider/update`,
    UPDATESTATUSPROVIDER: `${HOST}${VERSION}admin/provider/updateStatus`,
    CREATENUMBER: `${HOST}${VERSION}admin/provider/createNumber`,
    EXPORTNUMBERS: `${HOST}${VERSION}admin/provider/exportNumbers`,
    EXTRAPOLATENUMBERS: `${HOST}${VERSION}admin/provider/extrapolateNumbers`,
    EXTRAPOLATENUMBERSJSON: `${HOST}${VERSION}admin/provider/extrapolateNumbersJson`,
    EXTRAPOLATE_NUMBERS_FROM_EXCEL: `${HOST}${VERSION}admin/provider/extrapolateNumbersFromExcel`,
    DELETE_PROVIDER_FILE: `${HOST}${VERSION}admin/provider/delete-file`,
    LIST_EXTRAPOLATED_NUMBERS: `${HOST}${VERSION}admin/provider/listExtrapolatedNumbers`,
    TOTALAGENTS: `${HOST}${VERSION}admin/provider/totalAgents`,
    VALIDATE_UPLOAD_PHONES: `${HOST}${VERSION}admin/provider/validateUploadPhones`,
    GENERATE_MISSING_NUMBERS_JSON: `${HOST}${VERSION}admin/provider/generateMissingNumbersJson`,
    // Assignment
    SAVE_ASSIGNED_NUMBERS: `${HOST}${VERSION}admin/provider/saveAssignedNumbers`,
    RE_ASSIGNMENT_NUMBERS: `${HOST}${VERSION}admin/provider/reAssignmentNumbersRandom`,
    RE_ASSIGNMENT_NUMBERS_AGENT_TO_AGENTS: `${HOST}${VERSION}admin/provider/reAssignNumbersAgentToAgents`,
    // Notifications
    GET_NUMBER_REQUESTS: `${HOST}${VERSION}app/request/getNumberRequests`,
    // Validations
    VALIDATED_NUMBER_REQUESTS: `${HOST}${VERSION}app/request/db`,
    VALIDATED_SALES_IDS: `${HOST}${VERSION}admin/request/saleValidationDB`,
    UPDATES_VALIDATED_SALES_IDS: `${HOST}${VERSION}admin/request/updateSaleValidationDB`,
    GET_PROJECT_BY_DB: `${HOST}${VERSION}app/request/getProjectByDB`,
    GET_DAYLY_SUMARY: `${HOST}${VERSION}admin/provider/agentDailySummary`,
    // CRUD DB ADMIN
    GET_DBS: `${HOST}${VERSION}app/request/listdb`,
    CREATE_DBS: `${HOST}${VERSION}app/request/createdb`,
    UPDATE_DBS: `${HOST}${VERSION}app/request/updatedb`,
    DELETE_DBS: `${HOST}${VERSION}app/request/deletedb`,
    // Transfer sales
    TRANSFER_PROJECT_TO_PROJECT: `${HOST}${VERSION}app/request/transferProjectToProject`,
    GET_PROJECT_SALESMEN: `${HOST}${VERSION}app/request/getProjectSalesmen`,
    GET_PROJECT_NPNS: `${HOST}${VERSION}app/request/getProjectNpns`,

}

export default APP_URL